import { FilledType, HistoricalOrderType, OrderType } from 'data/Order/types'

import * as AT from './actionTypes'
import { actions as positions } from './positions/slice'
import { TransferType } from './types'

export type HistoricalActionType =
  | {
      payload: { readonly days?: number }
      type: typeof AT.GET_FILLED_ORDERS
    }
  | { type: typeof AT.GET_ORDERS }
  | { type: typeof AT.GET_TRANSFERS }
  | {
      payload: { readonly days?: number; readonly limit?: number }
      type: typeof AT.GET_FILLED_TRADES
    }
  | {
      payload: { readonly filledOrders: Array<OrderType> }
      type: typeof AT.SET_FILLED_ORDERS
    }
  | {
      payload: { readonly orders: Array<HistoricalOrderType> }
      type: typeof AT.SET_ORDERS
    }
  | {
      payload: { readonly filledTrades: Array<FilledType> }
      type: typeof AT.SET_FILLED_TRADES
    }
  | {
      payload: { readonly order: OrderType }
      type: typeof AT.SET_ORDER_DETAIL
    }
  | {
      payload: { readonly transfers: Array<TransferType> }
      type: typeof AT.SET_TRANSFERS
    }
  | {
      payload: { readonly status: boolean }
      type: typeof AT.SET_CAN_LOAD_MORE
    }
  | {
      payload: { readonly status: boolean }
      type: typeof AT.SET_IS_LOADING_ORDERS
    }
  | {
      payload: { readonly status: boolean }
      type: typeof AT.SET_IS_LOADING_TRADES
    }
  | {
      payload: { readonly lookback: number }
      type: typeof AT.SET_LOOKBACK
    }

const getOrders = (): HistoricalActionType => ({
  type: AT.GET_ORDERS
})

const getFilledTrades = (days?: number, limit?: number): HistoricalActionType => ({
  payload: { days, limit },
  type: AT.GET_FILLED_TRADES
})

const getFilledOrders = (days?: number): HistoricalActionType => ({
  payload: { days },
  type: AT.GET_FILLED_ORDERS
})

const setOrders = (orders: Array<HistoricalOrderType>): HistoricalActionType => ({
  payload: { orders },
  type: AT.SET_ORDERS
})

const setFilledTrades = (filledTrades: Array<FilledType>): HistoricalActionType => ({
  payload: { filledTrades },
  type: AT.SET_FILLED_TRADES
})

const setFilledOrders = (filledOrders: Array<OrderType>): HistoricalActionType => ({
  payload: { filledOrders },
  type: AT.SET_FILLED_ORDERS
})

const setDisplayedOrder = (order: OrderType): HistoricalActionType => ({
  payload: { order },
  type: AT.SET_ORDER_DETAIL
})

const setTransfers = (transfers: Array<TransferType>): HistoricalActionType => ({
  payload: { transfers },
  type: AT.SET_TRANSFERS
})

const setCanLoadMore = (status: boolean): HistoricalActionType => ({
  payload: { status },
  type: AT.SET_CAN_LOAD_MORE
})

const setIsLoadingOrders = (status: boolean): HistoricalActionType => ({
  payload: { status },
  type: AT.SET_IS_LOADING_ORDERS
})

const setIsLoadingTrades = (status: boolean): HistoricalActionType => ({
  payload: { status },
  type: AT.SET_IS_LOADING_TRADES
})

const setLookback = (lookback: number): HistoricalActionType => ({
  payload: { lookback },
  type: AT.SET_LOOKBACK
})

export default {
  getFilledOrders,
  getFilledTrades,
  getOrders,
  positions,
  setCanLoadMore,
  setDisplayedOrder,
  setFilledOrders,
  setFilledTrades,
  setIsLoadingOrders,
  setIsLoadingTrades,
  setLookback,
  setOrders,
  setTransfers
}
